<template>
  <div class="validated-field" :class="{ 'validated-field-required': required, 'validated-field-invalid': !!error }" :data-validation-field="field || null" :data-field-invalid="error ? 'true' : null">
    <slot :invalid="!!error" :feedback-id="feedbackId" />
    <div v-if="error" ref="feedback" :id="feedbackId" class="field-validation-feedback">{{ error }}</div>
  </div>
</template>
<script>
export default {
  name: 'ValidatedField',
  props: { field: String, error: { type: String, default: '' }, required: Boolean },
  computed: { feedbackId() { return 'field-feedback-' + this._uid } },
  mounted() { this.syncAccessibility() },
  updated() { this.syncAccessibility() },
  methods: {
    syncAccessibility() {
      const control = this.$el.querySelector('input, select, textarea')
      if (!control) return
      // Preserve help-text IDs supplied by the original control.
      // Relationship hosts may prefix IDs after rendering. Keep the actual DOM
      // node so its scoped ID is also removed when the feedback disappears.
      const feedback = this.$refs.feedback
      const ownIds = [this.feedbackId, feedback && feedback.id, this._validationFeedbackNode && this._validationFeedbackNode.id]
      const descriptions = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(id => id && !ownIds.includes(id))
      if (this.error) descriptions.push(feedback ? feedback.id : this.feedbackId)
      this._validationFeedbackNode = feedback
      if (descriptions.length) control.setAttribute('aria-describedby', descriptions.join(' '))
      else control.removeAttribute('aria-describedby')
      if (this.error) {
        control.setAttribute('aria-invalid', 'true')
        control.dataset.fieldValidationError = 'true'
      } else if (control.dataset.fieldValidationError) {
        control.removeAttribute('aria-invalid')
        delete control.dataset.fieldValidationError
      }
      control.setAttribute('aria-required', this.required ? 'true' : 'false')
      const label = this.$el.querySelector('label')
      if (label && !label.htmlFor) {
        if (!control.id) control.id = 'validated-control-' + this._uid
        label.htmlFor = control.id
      }
    }
  }
}
</script>
<style>
.validated-field { min-width: 0; }
.validated-field-required > label::after { content: ' *'; }
.validated-field-invalid > .form-control,
.validated-field-invalid > .form-select,
.validated-field-invalid .vs__dropdown-toggle { border-color: #dc3545 !important; }
.validated-field-invalid > .form-control:focus,
.validated-field-invalid > .form-select:focus,
.validated-field-invalid .vs--open .vs__dropdown-toggle { box-shadow: 0 0 0 .2rem rgba(220, 53, 69, .15) !important; }
.field-validation-feedback { color: #b42332; font-size: 12px; line-height: 1.4; margin-top: 5px; }
</style>
